import { LOG_ERROR } from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import { handleError, toastError } from "../../utils/AppFunctions";
export interface IApplicationError {
  device_name?: string;
  version?: string;
  browser_name?: string;
  browser_version?: string;
  os?: string;
  os_version?: string;
  url?: string;
  errorTime?: string;
  error_name?: string;
  error_message?: string;
  error_stack?: string;
  function_name?: string;
}

export const logApplicationError = async (payload: IApplicationError) => {
  try {
    let resultError;
    resultError = await LOG_ERROR(payload);
    if (resultError && resultError.code === DEFAULT_STATUS_CODE_SUCCESS) {
      return;
    } else {
      toastError(resultError?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    }
  } catch (error: any) {
    toastError(error?.resultError?.message || MESSAGE_UNKNOWN_ERROR_OCCURRED);
    handleError(error, "logApplicationError");
  }
};
